import { lazy } from "react";
import Loadable from "app/components/Loadable";

const WhatsAppWalletPage = Loadable(
  lazy(() => import("./WhatsAppWalletPage"))
);

const WhatsAppWalletRoutes = [
  {
    path: "/admin/whatsapp-wallet",
    element: <WhatsAppWalletPage />,
  },
];

export default WhatsAppWalletRoutes;
